"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var acceptSharedCalendarInviteOperation_1 = require("owa-service/lib/operation/acceptSharedCalendarInviteOperation");
var ServiceRequestUtils_1 = require("owa-service/lib/ServiceRequestUtils");
function acceptSharedCalendarInvite(messageId) {
    return acceptSharedCalendarInviteOperation_1.default({
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        Body: {
            MessageId: messageId,
        },
    }).then(function (response) {
        return response.Body;
    });
}
exports.default = acceptSharedCalendarInvite;
//# sourceMappingURL=acceptSharedCalendarInvite.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-sharing-accept/lib/services/acceptSharedCalendarInvite.js
// module id = 5805
// module chunks = 96